import { toast } from '@/components/toast';
import { GetTranslationsResponse, getTranslationsVideos } from '@/services/api';
import { logger } from '@/services/logger';
import { useQuery, UseQueryResult } from 'react-query';
import { GET_TRANSLATIONS_KEY } from './translationLibrary';

const FIVE_MINUTES = 1000 * 60 * 5;

interface UseGetTranslationsOptions {
    refetchInterval?: number | false;
}

export function useGetTranslations(
    isAnonymous?: boolean,
    groupId?: string,
    enabled: boolean = true,
    options?: UseGetTranslationsOptions
): UseQueryResult<GetTranslationsResponse> {
    const query = useQuery<GetTranslationsResponse>(
        groupId ? [GET_TRANSLATIONS_KEY, groupId] : GET_TRANSLATIONS_KEY,
        () => {
            if (isAnonymous) {
                return { translations: [] };
            }

            return getTranslationsVideos(groupId);
        },
        {
            staleTime: FIVE_MINUTES,
            enabled,
            refetchOnWindowFocus: false,
            refetchInterval: options?.refetchInterval,
            keepPreviousData: true,
            onError: err => {
                logger.error('Could not fetch translations', { err });
                toast.error({ title: 'Could not fetch translations', toastId: `${GET_TRANSLATIONS_KEY}-error` });
            },
            select: ({ translations, ...rest }) => ({
                ...rest,
                translations: translations.filter(({ persist }) => !!persist),
            }),
        }
    );

    return query;
}
